<template>
  <div id="venues">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto" v-if="true">
          <li class="nav-item">
            <el-button
              icon="el-icon-present"
              type="warning"
              size="small"
              round
              @click="
                $store.state.promotionhistory.filter.promotionIDs = [];
                promotionModal = true;
              "
            >
              {{ $t("event.table.distPromotions") }}
            </el-button>
          </li>
          <li class="nav-item">
            <el-tooltip class="item" effect="dark" :content="$t('onsiteUtilities.promotions.searchFilter')" placement="top">
              <el-button icon="fas fa-search" :type="$store.state.promotions.filter.searchTerm != '' && $store.state.promotions.filter.searchTerm != null ? 'success' : ''" size="small" circle @click="isFilterEnabled = !isFilterEnabled"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                updateForm = null;
                modalVisible = true;
              "
            >
              {{ $t("onsiteUtilities.promotions.addPromotion") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ $t("onsiteUtilities.promotions.filter") }}</h5>
                <span>{{ $t("onsiteUtilities.promotions.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="$store.state.promotions.filter.searchTerm = ''" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round>{{ $t("event.buttons.close") }}</el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-12">
                  <el-input clearable v-model="$store.state.promotions.filter.searchTerm" :placeholder="$t('onsiteUtilities.promotions.searchPlaceholder')"></el-input>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.promotions.title") }}</h5>
              <span v-if="$store.state.promotions.items.length > 0" v-html="$t('totalContent', [$store.state.promotions.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/detail/how-to-use-promotional-products-system')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body" v-if="false">
            <upgrade-overlay height="200px"></upgrade-overlay>
          </div>
          <div class="card-body" v-else-if="$store.state.promotions.items.length > 0">
            <div class="custom-grid-table-header promotions-grid-template">
              <!-- <span><i v-show="loading == 'loadingList'" class="el-icon-loading"></i></span> -->
              <span>{{ $t("onsiteUtilities.promotions.title") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.stockDistributed") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.remainder") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.view") }}</span>
              <span></span>
            </div>
            <div class="promotions-container">
              <div class="item" v-for="item in $store.state.promotions.items" :key="item.id" :class="{ passive: !item.isActive }">
                <!-- <span><i class="el-icon-s-grid burger"></i></span> -->
                <div class="price-title">{{ item.title }}</div>
                <span class="remainder">
                  {{ item.usage }}
                  <b>/ {{ item.stock }}</b>
                </span>
                <div class="remainder">{{ item.stock - item.usage }}</div>
                <div><el-switch v-model="item.isActive" :disabled="loading == item.id" @change="toggleItem(item.id)"></el-switch></div>
                <div style="display:flex; flex-direction:row;gap:.5rem">
                  <el-tooltip effect="dark" :content="$t('event.table.edit')" placement="top">
                    <el-button
                      type="primary"
                      icon="fas fa-pen"
                      circle
                      size="mini"
                      @click="
                        updateForm = item.id;
                        modalVisible = true;
                      "
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button slot="reference" type="danger" :loading="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-promotion-lottie'"
              :title="$t('event.menu.promotions.title')"
              @btnAdd="
                updateForm = null;
                modalVisible = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="modalVisible" :title="updateForm != null ? $t('onsiteUtilities.promotions.editPromotion') : $t('onsiteUtilities.promotions.addPromotion')" class="large" center modal-append-to-body destroy-on-close>
      <PromotionAddUpdate @deleteMe="deleteItem" @closeDialog="modalVisible = false" v-if="modalVisible" :id="updateForm" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="promotionModal" :title="$t('event.table.distPromotions')" class="large" center modal-append-to-body destroy-on-close>
      <PromotionHistory v-if="promotionModal" @closeDialog="promotionModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import PromotionAddUpdate from "../../components/PromotionAddUpdate";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import PromotionHistory from "../../pages/event/PromotionHistory";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.promotions")
    };
  },
  components: { PromotionAddUpdate, PageCountInfo, PromotionHistory },
  name: "Promotions",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      loading: null,
      listShort: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
      promotionModal: false,
      loading: false
    };
  },
  methods: {
    async toggleItem(id) {
      this.loading = id;
      await this.$store.dispatch("togglePromotions", id);
      await this.$store.dispatch("getPromotions");
      setTimeout(() => {
        this.loading = false;
      }, "500");
    },

    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getPromotions");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },

    deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("deletePromotion", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getPromotions");
        }
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleVenue", { index, value });
    },

    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    }
  },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.$store.dispatch("getPromotions");
      this.loading = false;
    }, 500);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    skip() {
      return (this.$store.state.promotions.filter.page - 1) * this.$store.state.promotions.filter.take;
    },
    take() {
      return this.skip + this.$store.state.promotions.items.length;
    }
  },
  watch: {
    "$store.state.promotions.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPromotions");
      }, 500);
    }
  }
};
</script>
<style lang="less" scoped>
.promotions-grid-template {
  grid-template-columns: 1fr 120px 120px 90px 90px;
}
.promotions-container {
  display: flex;
  flex-direction: column;

  .item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }
    .img-title {
      font-size: 14px;
      color: #292f3b;
      font-weight: 600;
      line-height: normal;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          font-weight: bold;
        }
        span {
          font-weight: 600;
          color: #ccc;
        }
      }
      & > img {
        border-radius: 50%;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      &.me {
        color: #ccc;
      }
    }
    display: grid;
    grid-template-columns: 1fr 120px 120px 90px 90px;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;
    .remainder {
      padding: 5px 10px;
      width: max-content;
      border-radius: 8px;
      background-color: rgba(255, 255, 255, 0.8);
      font-weight: 600;
      color: #505763;
      font-size: 13px;
    }
    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
    }

    .limit {
      font-weight: 500;
      color: #292f3b;

      .isLimited {
        color: #505763;
        b {
          color: #292f3b;
          font-weight: 600;
        }
      }
    }

    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      &.me {
        color: #ccc;
      }
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.loading-list {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  i {
    font-size: 20px;
    color: blueviolet;
    font-weight: bold;
  }
}
.collapse-btn-quest-icon {
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.5s;
  &.active {
    transform: rotate(-180deg);
  }
}
</style>
<style>
.modal-base-mini {
  min-width: 500px;
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Promotions.vue